module.exports = __webpack_public_path__ + "static/img/block-bg4.93cf5b76.png";